import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import logo from '/logo.svg';

const LoginExpired = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full items-center justify-center max-h-screen">
      <div className="flex flex-col border py-14 px-10 rounded-2xl border-[#CBCBCB] bg-[#fff] md:w-80">
        <div className="justify-center items-center flex">
          <img src={logo} alt="logo" />
        </div>
        <div className="text-3xl font-bold mt-10 mb-3 justify-center items-center flex md:text-2xl md:mt-6">
          {t('linkExpired')}
        </div>
        <span className="text-base text-center text-[#757575] justify-center items-center flex">
          <span className="whitespace-nowrap">{t('sendMessageTo')} &nbsp;</span>
          <br />
          <span
            onClick={() => navigate('/auth/login-all')}
            className="decoration-solid underline text-[#171717] cursor-pointer md:hidden"
          >
            support@omya.com
          </span>
        </span>
        <span className="hidden md:flex md:text-center md:justify-center md:underline md:cursor-pointer">
          support@omya.com
        </span>
        <span className="text-base text-center text-[#757575] justify-center items-center flex">
          {t('toGetLink')}
        </span>
      </div>
    </div>
  );
};

export default LoginExpired;
